import {
  Container,
  Box,
  Stack,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import logo from "../../resources/images/logo_full.svg";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const theme = useTheme();
  const changeLayout = useMediaQuery("(min-width:546px)");
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: "#FFF" }}>
      <Container maxWidth={"xl"}>
        <Box
          sx={{
            mx: { md: "90px", sm: "20px", xs: "4px" },
            pt: { sm: "80px", xs: "40px" },
            pb: { sm: "60px", xs: "30px" },
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: { lg: "270px", sm: "250px", xs: "240px" },
              mx: "auto",
            }}
          >
            <img alt="logo" src={logo} width={"100%"} />
          </Box>
          <Box
            sx={{
              width: "fit-content",
              mx: "auto",
              color: "black",
              fontSize: "17px",
              fontWeight: 700,
              mt: "24px",
              mb: "42px",
            }}
          >
            <Typography
              sx={{
                fontFamily: theme.typography.secondaryFontFamily,
                fontWeight: 700,
                fontSize: "17px",
                lineHeight: "21.42px",
              }}
            >
              We Are One of You..! Your Journey is Our Mission, Turning Dreams
              into Real Opportunities Together
            </Typography>
          </Box>
          <Stack
            direction={changeLayout ? "row" : "column-reverse"}
            alignItems={"center"}
            justifyContent={"space-between"}
            columnGap={5}
            rowGap={2}
            flexWrap={"wrap"}
          >
            <Typography sx={{ color: "black" }}>
              © 2024 Pitchblu. All rights reserved
            </Typography>
            <Stack direction={"row"} gap={5}>
              <Button
                onClick={() => navigate("/careers")}
                sx={{
                  fontSize: "18px",
                  textDecoration: "underline",
                  color: "black",
                  fontWeight: 400,
                  p: 0,
                }}
              >
                Careers
              </Button>
              <Button
                onClick={() => navigate("/contact-us")}
                sx={{
                  fontSize: "18px",
                  textDecoration: "underline",
                  color: "black",
                  fontWeight: 400,
                  p: 0,
                }}
              >
                Contact us
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
